// FR-AD7 "a banner visible to that user": rendered app-wide (mounted once in App.tsx, inside
// SessionProvider) whenever `/auth/me` reports `impersonation` — i.e. only on a session
// `POST /auth/impersonate/consume` created (ops.rs's `start_impersonation` /
// auth::handlers::impersonate_consume). Ending it is just an ordinary sign-out: the
// impersonated session is a real session row, nothing special to unwind.
import { Button, Callout } from "@grackle/ui";
import { useSession } from "../session";

export default function ImpersonationBanner() {
  const { impersonation, signOut } = useSession();
  if (!impersonation) return null;

  // Neither red nor amber (both are reserved): status carries as an icon plus an explicit sentence.
  return (
    <Callout tone="info" icon="eye" role="status" className="impersonation-bar">
      <strong>{impersonation.by_email}</strong> (Grackle staff) is viewing your account on your behalf — {impersonation.reason}
      <Button variant="secondary" size="sm" onClick={() => void signOut()}>
        End session
      </Button>
    </Callout>
  );
}
